import Subscription from './Subscription';

export default Subscription;
